module.exports = __webpack_public_path__ + "img/dgslg-currency-guide-ru-2.77db7e34.png";